export enum MatchingEndpoint {
  NextAvailable = 'nextAvailable',
  Scheduled = 'scheduled',
  FlagDown = 'flagDown',
}
